import React from 'react';
import PropTypes from 'prop-types';
import { GearIcon, PersonIcon } from '@primer/octicons-react';
import NavigationMenu from './NavigationMenu';

/**
 * Composant du menu compte utilisateur
 * Affiche les options de compte selon le statut de connexion
 * 
 * @param {Object} props - Props du composant
 * @param {Object} props.me - Utilisateur connecté
 * @param {string} props.menuOpened - Clé du menu actuellement ouvert
 * @param {Array} props.accountOptions - Options du compte
 * @param {Function} props.handleMenu - Handler pour les clics sur le menu
 * @param {Function} props.getIconTag - Fonction pour obtenir les icônes
 * @param {Function} props.t - Fonction de traduction
 * @returns {JSX.Element} Composant NavigationAccount
 */
const NavigationAccount = ({ 
  me, 
  menuOpened, 
  accountOptions, 
  handleMenu, 
  getIconTag, 
  t 
}) => {
  const title = me ? {
    icon: getIconTag(GearIcon),
    label: t("navigation.myaccount")
  } : {
    icon: getIconTag(PersonIcon),
    label: t("navigation.myaccount")
  };

  const options = me ? accountOptions : [
    { icon: getIconTag(PersonIcon), label: t("navigation.connect"), link: "/login" }
  ];

  return (
    <NavigationMenu
      menuKey="account"
      menuOpened={menuOpened}
      title={title}
      options={options}
      handleMenu={handleMenu}
    />
  );
};

NavigationAccount.propTypes = {
  me: PropTypes.object,
  menuOpened: PropTypes.string,
  accountOptions: PropTypes.array.isRequired,
  handleMenu: PropTypes.func.isRequired,
  getIconTag: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default NavigationAccount;
